// Facetwp refresh
document.addEventListener('facetwp-refresh', function() {
	const x = document.querySelectorAll("html");
	const z = document.querySelector(".facetwp-template");
	x[0].classList.remove("lock-scroll");
	z.style.opacity = '0';
});
document.addEventListener('facetwp-loaded', function() {
	const x = document.querySelectorAll("html");
	const z = document.querySelector(".facetwp-template");
	x[0].classList.remove("lock-scroll");
	z.style.opacity = '1';
});
